import { marketPlaceApi } from 'api'
import { MarketDTO } from 'types/applications/market'

export const fetchMarketsApi = () => marketPlaceApi.get<MarketDTO[]>('/countries')
